import { withProps } from 'recompose';
import { endingFirst, endRegistrationFirst, startingFirst } from '../helpers';
import { RACES_ORDER } from './constants';

export default withProps(({ racesOrder, leaderboards: lbs = [] }) => {
    const leaderboards = [...lbs];

    if (racesOrder === RACES_ORDER.startDate) {
        leaderboards.sort(startingFirst);
    }

    if (racesOrder === RACES_ORDER.endDate) {
        leaderboards.sort(endingFirst);
    }

    if (racesOrder === RACES_ORDER.registrationDate) {
        leaderboards.sort(endRegistrationFirst);
    }

    return {
        leaderboards
    };
});
